import { EmoticonDeadIcon } from './EmoticonDeadIcon';

/**
 * author: Google
 * id 187185AC-5567-44DC-AC70-14B0D89C270C
 * name emoticon-dead
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/emoticon-dead.svg
 * tags
 * - Emoji 
 */
export const EmojiDeadIcon = EmoticonDeadIcon;
export default EmojiDeadIcon